export class eBlockLookup
{
    startBlock: number;
    endBlock: number;
}

export class ePageLookup
{
    page: number;
    maxPageSize: number;
}

export interface ITransactionValue
{
    value: bigint;
    data?: string;
}

export interface ITransactionGas
{
    gasPrice?: bigint;     //price
    gasLimit: bigint;     //count
    maxFeePerGas?: bigint;
}

export interface ITransaction extends ITransactionValue, ITransactionGas
{
    from: string;
    to: string;
}

export interface ITransactionResponceEx extends ITransaction
{
    hash: string;
    timestamp: number;
    confirmations: number;
    blockNumber: number;
    nonce?: number;
    state?: number;
    signature?: string;

    gasUsed: bigint;     //count
}

//todo remove me
export interface ITransactionFee
{
    feeAmount: string; //gasPrice in gwei
    fee: string; //in ETH
    format: 'gwei';
    fiatFee: string; //in USD
}

//todo remove me
export interface ITransactionAmount
{
    value: string; //in ETH
    price: number; //in USD
}

export interface IStoreExplorer
{
    chainId: number;
    EVMExplorer: IBlockChainExplorer;
}

//todo remove me
export interface ITransactionParsed extends ITransactionResponceEx
{
    amount: ITransactionAmount;
    fee: ITransactionFee;
}

//all gases in Gwei
//todo change to BN
export interface IGasOracle
{
    safeGasPrice: string,
    proposeGasPrice: string,
    fastGasPrice: string,
}

export interface IFee
{
    amount: string;
    priorityAmount: string;
    time: number;
}

export interface IOracleFee
{
    safe: IFee,
    propose: IFee,
    fast: IFee;
}

export interface IGas
{
    price: string;
    priorityAmount?: string;
}

export interface IOracleGas
{
    safeGasPrice: IGas;
    proposeGasPrice: IGas;
    fastGasPrice: IGas;
}

export interface IGasStats
{
    average: number,
    fast: number,
    slow: number,
}

export interface IBlockChainExplorer
{
    GetBlockNumber(): Promise<number>;

    /**
     * If contractAddress not null
     * Get a list of "ERC20 - Token Transfer Events" by Address.
     * Else Get a list of 'Normal' Transactions By Address.
     * @param address
     * @param contractAddress
     * @param lookSettings
     */
    GetHistory(
        address: string,
        contractAddress: string,//pass null for ETH
        lookSettings: ePageLookup | eBlockLookup): Promise<ITransactionResponceEx[]>;

    /**
     * (SafeGasPrice, ProposeGasPrice And FastGasPrice returned in Gwei)
     */
    GetGasOracle(): Promise<IOracleGas>;

    /**
     * Result returned in seconds, gasprice value in Wei
     * @param gasPrice
     */
    GetEstimatationOfConfirmTime(gasPrice: string): Promise<number>;

    GetContractABI(address: string): Promise<string>;
}

export enum eRejectFailReason
{
    NONE,
    FAIL,
    FAIL_BY_LIMIT_REACHED,
}
